"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var useBulkMutation_1 = require("../useBulkMutation/useBulkMutation");
function useMutation(mutationArgs) {
    var onSuccess = React.useCallback(function (results) {
        mutationArgs.onSuccess && mutationArgs.onSuccess(results[0]);
    }, [mutationArgs.onSuccess]);
    var _a = useBulkMutation_1.default(__assign(__assign({}, mutationArgs), { onSuccess: onSuccess })), reset = _a.reset, bulkInvoke = _a.invoke, results = _a.results;
    var invoke = React.useCallback(function (args) {
        bulkInvoke([args]);
    }, [bulkInvoke]);
    var result = results && results[0];
    return {
        invoke: invoke,
        reset: reset,
        result: result,
    };
}
exports.default = useMutation;
//# sourceMappingURL=useMutation.js.map